import { useEffect } from 'react'

// Runs `callback` once, after the initial document load has finished and the
// browser reports an idle moment (falling back to a 1s timeout when
// requestIdleCallback isn't available). Used to warm caches (React Query
// data, large binary payloads, etc.) without competing with the first
// page render.
export function useIdlePrefetch(callback: () => void): void {
  useEffect(() => {
    const idleApi = window as unknown as {
      requestIdleCallback?: (cb: () => void) => number
      cancelIdleCallback?: (id: number) => void
    }
    let idleId: number | undefined
    let timeoutId: ReturnType<typeof setTimeout> | undefined
    const run = () => { callback() }
    const schedule = () => {
      if (typeof idleApi.requestIdleCallback === 'function') idleId = idleApi.requestIdleCallback(run)
      else timeoutId = setTimeout(run, 1000)
    }

    if (document.readyState === 'complete') schedule()
    else window.addEventListener('load', schedule, { once: true })

    return () => {
      window.removeEventListener('load', schedule)
      if (idleId !== undefined) idleApi.cancelIdleCallback?.(idleId)
      if (timeoutId !== undefined) clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
